export enum ProblemUnsolvedReasons {
  DIFFERENT_PROBLEM = "DIFFERENT_PROBLEM",
  WITHOUT_MATERIALS = "WITHOUT_MATERIALS",
  OTHER = "OTHER",
}
